import { isAnalyticsEligible } from './analyticsEligibility';

const configuredTrackingIds = new Set();

const ensureGoogleDataLayer = () => {
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== 'function') {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }
};

export const initGoogleTagManager = (trackingId) => {
  if (!isAnalyticsEligible()) {
    return false;
  }

  ensureGoogleDataLayer();

  // Check if script is already present
  const scriptId = 'google-tag-manager-script';
  if (document.getElementById(scriptId)) {
    if (configuredTrackingIds.has(trackingId)) {
      return false;
    }
  } else {
    const script = document.createElement('script');
    script.id = scriptId;
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;

    document.head.appendChild(script);
  }

  window.gtag('consent', 'default', {
    analytics_storage: 'denied',
  });

  window.gtag('js', new Date());

  window.gtag('config', trackingId, {
    send_page_view: false,
  });

  configuredTrackingIds.add(trackingId);
  return true;
};
